import React from 'react'
import { Redirect } from 'react-router-dom'
import jwt_decode from "jwt-decode";

class ProtectedRouteAdmin extends React.Component {

    render() {
        const Component = this.props.component;
        var user = JSON.parse(sessionStorage.getItem("user"));
        var bol = false;
        // if(user != null)
        var decoded = jwt_decode(user.token);
        bol = decoded.RUOLO == 4?true:false;  
        const isAdmin = bol;
        return isAdmin ? (
            <Component />
        ) : (
            <Redirect to={{ pathname: '*' }} />
        );
    }
}

export default ProtectedRouteAdmin;